import { Box, Flex, Grid, xcss } from '@atlaskit/primitives';
import React from 'react';

type PageSectionProps = {
	children: React.ReactNode;
};

const pageStyles = xcss({
	paddingTop: 'space.300',
	paddingBottom: 'space.300',
	width: '70%',
});

export const PageSection = ({ children }: PageSectionProps) => {
	return (
		<Grid alignItems="center" templateColumns="1fr">
			<Flex alignItems="center" justifyContent="center">
				<Box xcss={pageStyles}>{children}</Box>
			</Flex>
		</Grid>
	);
};
